// extracted by mini-css-extract-plugin
export default {"container":"SingleProduct_container__nMJ4A","wrapper":"SingleProduct_wrapper__TAGvY"};